<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li class="picto"><a routerLink="/">Accueil</a></li>
                <li class="picto"><a routerLink="/studies">Etudes</a></li>
                <li class="picto">Niveau {{number}}</li>
            </ul>
            <h2>
                <i class=" iconModule bx bx-chalkboard"></i> {{title}}
            </h2>
        </div>
    </div>

    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>



    <div class="container">
        <div class="row" #update [hidden]="hide" style="margin-top: 45px;">
            <div class="col-sms-12" style="text-align:left; font-size:14px">
                <div class="">
                    <div style="margin-bottom: 23px;font-weight:bold" class="card-header font-weight-bold">
                        {{elementSelected?.id?.split('-')[1]}}
                    </div>
                    <div class="card-body">
                        <div style="margin-bottom: 15px;align-items: normal !important;">
                            <div *ngIf="(errorForm || messageForm)"
                                [ngClass]="{'text-danger':errorForm,'text-success':messageForm, 'bg-danger':errorForm,'bg-success':messageForm}"
                                class="card">
                                <ul class="list-group list-group-flush ">
                                    <li style="font-size: 13px;" class="list-group-item"
                                        [ngClass]="{'text-danger':errorForm,'text-success':messageForm}">
                                        {{errorForm||messageForm}}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label for="formFile" class="form-label" style="color:#ccc">Pdf<span
                                    style="color:red">*</span></label>
                            <input #file3 accept=".pdf" class="form-control pdfinput" type="file"
                                (change)="selectFilePdf($event)" id="formFile">
                        </div>
                        <div class="mb-3" *ngIf="level !='level3' && level !='level4'">
                            <label style="color:#ccc" for="formFile" class="form-label">Power point<span
                                    style="color:red">*</span></label>
                            <input #file1 accept=".pptx" class="form-control" type="file" (change)="selectFile($event)"
                                id="formFile">
                        </div>
                        <div class="mb-3" *ngIf="level=='level3' || level=='level4'">
                            <label style="color:#ccc" for="formFile" class="form-label">Document word<span
                                    style="color:red">*</span></label>
                            <input #file2 accept=".docx,.doc" class="form-control" type="file"
                                (change)="selectFile($event)" id="formFile">
                        </div>
                        (<span style="color:red">*</span>)<span style="color:#ccc">Obligatoire</span>
                    </div>
                </div>
                <button [disabled]="spinnerForm" (click)="submitUpdate()" style="margin-bottom: 23px;background-color:white!important;margin-top: 23px;
                            color:black;border-width: 3px;font-weight:bold;border-color: #9b215cde;"
                    class="btn btn-success btn-sm">
                    Soumettre
                    <span *ngIf="spinnerForm" style="height: 19px;
                            width: 19px;
                            margin-left: 13px;" class="spinner-border spinner"></span>
                </button>
            </div>
        </div>


        <div class="row h-100 justify-content-center align-items-center">
            <div class="container">

                <div class="row h-100 justify-content-center align-items-center">

                    <div class="col-sms-12 col-lg-7 col-md-7">
                        
                        <form >
                            <div class="row no-gutters align-items-center spec">
                                <div class="col">
                                    <div class="card-grid">
                                        <div class="card">
                                            <div class="card-content">
                                                <div class="card-text">
                                                    <button [disabled]="!isChangedItems  || spinnerShare" (click)="share()" style="cursor:pointer;margin-bottom: 23px;background-color:white!important;
                                                    color:black;border-width: 3px;font-weight:bold;border-color: #9b215c;"
                                                        class="btn btn-success btn-sm">
                                                        <img *ngIf="!spinnerShare" src="assets/img/share.png" width="25" /><span
                                                            style="margin-left: 10px;">Partager</span>
                                                        <span *ngIf="spinnerShare" style="height: 19px;
                                                            width: 19px;
                                                            margin-left: 13px;" class="spinner-border spinner"></span>
                                                    </button>
  <i style="cursor:pointer;margin-left: 23px;" (click)="tooltipPopUp()"
                                class="fa fa-info-circle" ngbTooltip="" triggers="manual" #tooltip="ngbTooltip"></i>
                                                </div>
                                                <div class="card-image">
                                                    <img src="{{ moduleByLevel.picture }}" alt="image">
                                                </div>
                                                
                                            </div>


                                            <div class="row ">

                                            <div *ngIf="error || message"
                                            [ngClass]="{'text-danger':error,'text-success':message, 'border-danger':error,'border-success':message}"
                                            class="card" style="margin-top:34px;">
                                            <ul class="list-group list-group-flush">
                                                <li style="font-weight:bold" class="list-group-item"
                                                    >{{error||message}}
                                                </li>
                                            </ul>
                                        </div>
                                                <div *ngFor="let item of items | paginate: { itemsPerPage: count, currentPage: p }"
                                                    class="col-xl-6  col-sm-12 mb-4 d-flex justify-content-center">

                                                    <div class="cardText lesson w-100">
                                                        <div class="card-body">
                                                            <h5 class="card-title"
                                                                style="font-weight: bold;color: var(--bs-black) ;font-size: 18px;">{{
                                                                    item.title||item.id?.split('-')[1] }}
                                                            </h5>
                                                            <h6 class="card-subtitle mb-2 text-muted">
                                                                {{item.id?.split('_')[0].split('-')[0] }}</h6>
                                                            <p class="card-text"> <a style="font-size: 15px;
                                            font-weight: 600;" href="javascript: void(0)" (click)="download(item)">Je
                                                                    télécharge</a></p>

                                                            <div class="d-flex justify-content-end">
                                                                <div class="p-2 customStrah">
                                                                    <i style="color:#9b215c;position: relative;
                                                        top: -3.8px;" (click)="pop(item,content)"
                                                                        class="fa fa-file-pdf" aria-hidden="true"></i>
                                                                </div>
                                                                <div class="p-2 customStrah">
                                                                    <input style="position: relative;
                                                        top: -3.8px;" class="form-check-input"
                                                                        [checked]="item.unlocked" type="checkbox"
                                                                        (change)="item.unlocked=!item.unlocked;changeSelection(item)"
                                                                        name="checkbox-list" [attr.id]="item.id">
                                                                </div>
                                                                <div class="p-2 customStrah" (click)="updateCC(item)">
                                                                    <i style="color:#9b215c;margin-left: 1px;position: relative;
                                                        top: -3.8px;" class="fas fa-edit" aria-hidden="true"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div *ngIf="!spinnerTable " class="d-flex justify-content-end">
                                <pagination-controls previousLabel="" nextLabel="" (pageChange)="p = $event">
                                </pagination-controls>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div style="margin-top:40px" *ngIf="spinnerTable " class="d-flex align-items-center justify-content-center">
                <span style="color:#9b215c" class="spinner-border spinner"></span>
            </div>
        </div>
    </div>